// extracted by mini-css-extract-plugin
export var label = "_g1-2";
export var slideContainer = "_g1-0";
export var slider = "_g1-1";